import classnames from 'classnames';
import propTypes from 'prop-types';
import React from 'react';
import Date from '../../common/date';
import DateTime from '../../common/DateTime';
import { t } from '../../../modules/infra/i18n';

const getStatusDisplay = (status) => {
  const statusTranslations = {
    waiting: t('common:queue_status.waiting'),
    processing: t('common:queue_status.processing'),
    retrying: t('common:queue_status.retrying'),
    failed: t('common:queue_status.failed'),
    finished: t('common:queue_status.finished'),
  };
  return statusTranslations[status] || status;
};

const QueueItem = ({ email, createdAt, finishedAt, status, startDate, endDate }) => (
  <div className="u-fontsize-small u-border-bottom u-pv- dark-mode-white">
    <p>
      {t('register:queue_item.email')} {email}
    </p>
    <p display-if={startDate && endDate}>
      {t('register:queue_item.date_range')} <Date>{startDate}</Date> - <Date>{endDate}</Date>
    </p>
    <p>
      {t('register:queue_item.started_at')} <DateTime>{createdAt}</DateTime>
    </p>
    <p display-if={finishedAt}>
      {t('register:queue_item.finished_at')} <DateTime>{finishedAt}</DateTime>
    </p>
    <p>
      {t('register:queue_item.status')}{' '}
      <span
        className={classnames('u-type--bold', {
          'u-font-color-primary': status === 'finished',
          'u-font-color-red': status === 'failed',
        })}
      >
        {getStatusDisplay(status)}
      </span>
    </p>
  </div>
);

QueueItem.propTypes = {
  email: propTypes.string.isRequired,
  createdAt: propTypes.string.isRequired,
  finishedAt: propTypes.string,
  status: propTypes.string.isRequired,
  startDate: propTypes.string,
  endDate: propTypes.string,
};

QueueItem.defaultProps = {
  finishedAt: '',
  startDate: '',
  endDate: '',
};

export default QueueItem;
